import { computed } from "vue";
import { getPropertiesForWhichAllKeysExist } from "../index";
export default function computePropertiesForWhichAllKeysExist(object, excludedKeys) {
    return computed(() => {
        return getPropertiesForWhichAllKeysExist(object.value, excludedKeys.value);
    });
}
